export default __webpack_public_path__ + "static/media/servicio-5.8128ba72.webp";